
<template>
  <AppTemplate>
    <!--template #title>Tableau de bord</template-->
    <div class="dashboard-container">
      <h2 class="mb-4">Tableau de bord</h2>

      <GeneralStatsCards />
      
      <!-- Graphiques -->
      <div class="row">
        <div class="col-md-6 mb-4">
          <UserRegistrationChart />
        </div>
        
        <div class="col-md-6 mb-4">
          <UserCityDistributionChart />
        </div>
      </div>

    </div>
  </AppTemplate>
</template>

<script>
import GeneralStatsCards from '@/components/GeneralStatsCards.vue'
import UserRegistrationChart from '@/components/UserRegistrationChart.vue'
import UserCityDistributionChart from '@/components/UserCityDistributionChart.vue'

export default {
  name: 'HomeView',
  components: {
    GeneralStatsCards,
    UserRegistrationChart,
    UserCityDistributionChart
  },
  data() {
    return {

    }
  },
 
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.stat-card {
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

.bg-primary { background-color: #4e73df; }
.bg-success { background-color: #1cc88a; }
.bg-warning { background-color: #f6c23e; }
.bg-info { background-color: #36b9cc; }
</style>